var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_28585)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.526367,
    width: 33,
    height: 33,
    rx: 8,
    fill: "url(#paint0_linear_269_28585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.621 9.8183H11.5803C9.41416 9.8183 7.6582 11.5743 7.6582 13.7404V19.2597C7.6582 21.4258 9.41423 23.1818 11.5803 23.1818H22.621C24.7871 23.1818 26.5431 21.4257 26.5431 19.2597V13.7404C26.5431 11.5743 24.7871 9.8183 22.621 9.8183ZM19.9684 16.7685L14.8044 19.2314C14.6668 19.2971 14.5078 19.1969 14.5078 19.0444V13.9646C14.5078 13.8099 14.671 13.7097 14.8088 13.7797L19.9727 16.3965C20.1265 16.4743 20.1238 16.6945 19.9684 16.7685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_28585",
    x1: 17.0264,
    y1: 0,
    x2: 17.0264,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_28585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.95cf6f3fed7c168a37a632f31731dc70.svg";
export { ForwardRef as ReactComponent };